import React, { useState, useCallback } from "react";
import Noti from "../../../util/noti";
import AdminTable from "./AdminTable";

import SiteCreationChild from "./SiteCreationChild";

function SiteCreationExecutionTable() {
	return (
		<SiteCreationChild requiredRoles={['administration:SiteCreation:_admin']}>
			<AdminTable />
			<Noti />
		</SiteCreationChild>
	);
}

export default SiteCreationExecutionTable;
